
// import * as chart from 'chart.js'; // works

import {
	Chart,
	BarController,
	BarElement,
	LineController,
	LineElement,
	PointElement,
	CategoryScale,
	LinearScale,
	Title,
	SubTitle,
	Tooltip,
	Legend,
	Colors,
	Filler,
	// registerables // works
} from 'chart.js';


// import annotationPlugin from 'chartjs-plugin-annotation';
import autocolors from 'chartjs-plugin-autocolors';
// import ChartDataLabels from 'chartjs-plugin-datalabels';


Chart.register(
	BarController,
	BarElement,
	LineController,
	LineElement,
	PointElement,
	CategoryScale,
	LinearScale,
	Title,
	SubTitle,
	Tooltip,
	Legend,
	Colors,
	Filler,
	// annotationPlugin,
	autocolors,
	// ChartDataLabels,
);
// chart.register(...registerables);


import { maxIndex, maxLabel, maxValue, midValue, minValue } from '/functions.js';



(async function() {
	let theChart;
	const canvas = document.getElementById('canvas');
	const ctx = canvas.getContext('2d');

	const selectCounty = document.getElementById('selectCounty');
	let selectedCountyId = '1',
		selectedCountyData = [],
		stateAbbrev = 'CT';

	const storageKey = 'ctTaxRatesHistory';
	const storedItem = localStorage.getItem(storageKey);


	selectCounty.addEventListener('change', e => {
		selectedCountyId = e.target.value;
		makeChart();
	});


	let chartData = [];

	const formatDecimal = new Intl.NumberFormat('en-US', {
		style: 'decimal',
		minimumFractionDigits: 2,
		// maximumFractionDigits: 2
	});


	const getOrCreateLegendList = (chart, id) => {
		const legendContainer = document.getElementById(id);
		let listContainer = legendContainer.querySelector('ul');

		if (!listContainer) {
			listContainer = document.createElement('ul');
			listContainer.style.display = 'flex';
			listContainer.style.flexDirection = 'row';
			listContainer.style.margin = 0;
			listContainer.style.padding = 0;

			legendContainer.appendChild(listContainer);
		}

		return listContainer;
	};


	const htmlLegendPlugin = {
		id: 'htmlLegend',
		afterUpdate(chart, args, options) {
			const ul = getOrCreateLegendList(chart, options.containerID);

			// remove existing legend items
			while (ul.firstChild) {
				ul.firstChild.remove();
			}

			// repurpose the built-in legendItems generator
			const items = chart.options.plugins.legend.labels.generateLabels(chart);

			items.forEach((item, i) => {
				const li = document.createElement('li');
				// li.style.alignItems = 'center';
				// li.style.cursor = 'pointer';
				// li.style.display = 'flex';
				// li.style.flexDirection = 'row';
				// li.style.marginLeft = '10px';

				li.onclick = (event) => {
					if (i > 1) {

						let town = event.target.innerText;
						setSubtitleText(chart, town);

						// hide all datasets except county and state averages
						chart.data.datasets.forEach((item, i) => {
							if (i > 1) {
								chart.setDatasetVisibility(i, false);
							}
						});

						if (i > 1) {
							chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
						}

						chart.update();
					}
				};

				// Color box
				const boxSpan = document.createElement('span');
				boxSpan.style.background = item.fillStyle;
				// boxSpan.style.borderColor = item.strokeStyle;
				// boxSpan.style.borderWidth = item.lineWidth + 'px';
				// boxSpan.style.display = 'inline-block';
				// boxSpan.style.flexShrink = 0;
				boxSpan.style.height = '20px';
				boxSpan.style.marginRight = '10px';
				boxSpan.style.width = '20px';

				// County Average
				if (i === 0) {
					boxSpan.style.width = '0px';
					boxSpan.style.height = '0px';
					boxSpan.style.background = 'none';
					boxSpan.style.borderStyle = 'solid';
					boxSpan.style.borderWidth = '0 8px 13.9px 8px';
					boxSpan.style.borderColor = 'transparent transparent ' + item.fillStyle + ' transparent';
					boxSpan.style.Transform = 'rotate(0deg)';

					// boxSpan.style.height = '16px';
					// boxSpan.style.width = '16px';
					// boxSpan.style.borderRadius = '50%';
					// boxSpan.style.background = 'rgb(0, 128, 0)';
				}

				// State Average
				if (i === 1) {
					boxSpan.style.height = '16px';
					boxSpan.style.width = '16px';
					boxSpan.style.borderRadius = '50%';
					boxSpan.style.background = item.fillStyle; // 'rgb(0, 0, 128)';
				}


				// Text
				const textContainer = document.createElement('p');
				textContainer.style.color = item.fontColor;
				textContainer.style.margin = 0;
				textContainer.style.padding = 0;

				if (i > 1) {
					textContainer.style.textDecorationLine = item.hidden ? 'line-through' : 'none';
					// textContainer.style.textDecoration = item.hidden ? '' : 'green wavy underline';
				}

				const text = document.createTextNode(item.text);
				textContainer.appendChild(text);

				li.appendChild(boxSpan);
				li.appendChild(textContainer);
				ul.appendChild(li);
			});
		}
	};


    // if data is not in local storage, download Papa Parse
    // when Papa Parse is available, fetch and parse the data
    if (storedItem) {
        // makeSelect();
		makeChart(true);
	} else {
		const script = document.createElement('script');
		script.src = '/Scripts/libs/papaparse/5.4.1/papaparse.min.001.js';
		script.async = true;
		script.onload = () => {
			callPapaParse();
		};
		script.onerror = () => {
			// console.log('Error occurred while loading Papa Parse');
		};
		document.body.appendChild(script);
	}

    function callPapaParse() {
        // https://docs.google.com/spreadsheets/d/143bHZFCwxBm8jiymxXd-W8nyxfadFYCwa5gsvbJzaKc/edit?gid=207381997#gid=207381997
		Papa.parse('/Scripts/Data/CT/CT-Tax-Rates-History.csv', {
			download: true,
			complete: function (results) {
				if (results.errors.length === 0) {
					localStorage.setItem(storageKey, JSON.stringify(results.data));
					// makeSelect();
					makeChart();
				}
			},
			header: true,
			dynamicTyping: false,
			worker: false,
		});
	}

/*
	function makeSelect() {
		const counties = [
			{c: 'Fairfield', v: '1'},
			{c: 'Hartford', v: '3'},
			{c: 'Litchfield', v: '5'},
			{c: 'Middlesex', v: '7'},
			{c: 'New Haven', v: '9'},
			{c: 'New London', v: '11'},
			{c: 'Tolland', v: '13'},
			{c: 'Windham', v: '15'}
		],
		fragment = document.createDocumentFragment(),
		len = counties.length;

		for (let i = 0; i < len; i++) {
			const option = document.createElement('option');
			option.textContent = counties[i].c;
			option.value = counties[i].v;

			if (counties[i].v === '1') {
				option.selected = true;
			}

			fragment.appendChild(option);
		}

		selectCounty.appendChild(fragment);

		selectCounty.addEventListener('change', e => {
			selectedCountyId = e.target.value;
			makeChart();
		});
	}
*/


	function setSubtitleText(chart, town) {
		chart.options.plugins.subtitle.text = town + ', ' + stateAbbrev;
	}


	function makeChart() {
		if (!!theChart) {
			theChart.destroy();
			chartData.length = 0;
		}

		selectedCountyId = selectCounty.value;

		let storedData = JSON.parse(localStorage.getItem(storageKey));

		// filter data based on selected county
		if (storedData) {
			selectedCountyData.length = 0;
			selectedCountyData = storedData.filter(function (row) {
				return row['County'] === selectedCountyId; // prepend + to convert to int
			});
		} else {
			return;
		}

		function getData() {
			return chartData;
		}

		let minVal = 0;
		let maxVal = 50;


		// County Averages
		const annotation1 = {
			type: 'label',
			color: 'rgba(0, 0, 0, .8)',
			backgroundColor: 'rgba(128, 128, 128, .4)',
			callout: {
				display: true,
				borderColor: 'rgb(255, 0, 0)', // (ctx) => ctx.chart.data.datasets[0].borderColor
				position: 'bottom',
				borderWidth: 2,
			},
			content: ['County', 'Average'], // (ctx) => 'Maximum value is ' + maxValue(ctx).toFixed(2),
			font: {
				size: 14,
			},
			position: {
				x: 'center', // (ctx) => maxIndex(ctx) <= 3 ? 'start' : maxIndex(ctx) >= 10 ? 'end' : 'center',
				y: 'center'
			},
			xAdjust: 0, // (ctx) => maxIndex(ctx, 0) <= 3 ? 20 : maxIndex(ctx, 0) >= 10 ? -60 : 0,
			xValue: .5, // (ctx) => maxLabel(ctx, 0),
			yAdjust: -65,
			// yValue: (ctx) => Math.min(...ctx.chart.data.datasets[16].data), // maxValue(ctx)
			yValue: (ctx) => midValue(ctx, 0, 0, 1), // minValue(ctx, 0)
		};

		// State Averages
		const annotation2 = {
			type: 'label',
			color: 'rgba(0, 0, 0, .8)',
			backgroundColor: 'rgba(128, 128, 128, .4)',
			callout: {
				display: true,
				borderColor: 'rgb(0, 0, 128)', // (ctx) => ctx.chart.data.datasets[0].borderColor
				position: 'auto',
				borderWidth: 2,
			},
			content: ['State', 'Average'], // (ctx) => 'Maximum value is ' + maxValue(ctx).toFixed(2),
			font: {
				size: 14,
			},
			position: {
				x: 'center', // (ctx) => maxIndex(ctx) <= 3 ? 'start' : maxIndex(ctx) >= 10 ? 'end' : 'center',
				y: 'center'
			},
			xAdjust: 0, // (ctx) => maxIndex(ctx, 1) <= 3 ? 20 : maxIndex(ctx, 1) >= 10 ? -60 : 0,
			xValue: 5.5, // (ctx) => maxLabel(ctx, 1),
			yAdjust: -65,
			yValue: (ctx) => midValue(ctx, 1, 5, 6), // (ctx) => maxValue(ctx, 1)
		};


		// add State Averages
		chartData.push({
			label: 'State Average',
			data: [31.00, 31.33, 31.36, 31.24, 30.50, 29.73, 28.79],
			// datalabels: {
			// 	display: false,
			// 	align: 'end',
			// 	anchor: 'start',
			// 	backgroundColor: function (context) {
			// 		return context.dataset.borderColor;
			// 	},
			// 	borderRadius: 4,
			// 	color: 'white',
			// 	font: {
			// 		weight: 'bold',
			// 		size: 12,
			// 	},
			// 	offset: 8,
			// 	padding: 4,
			// 	// formatter: Math.round
			// },
			order: 0,
			type: 'line',
			borderDash: [1, 3],
			borderColor: 'rgba(0, 0, 0, .8)',
			borderWidth: 1,
			backgroundColor: 'rgb(0, 128, 0)',
			pointStyle: 'circle',
			pointRadius: 6,
			hoverBorderWidth: 10,
		});


		let countyAvgs = [];

		selectedCountyData.forEach((town, i) => {
			let townData = [],
			index = 0,
			val = 0.0,
			isHidden = i >= 1;

			for (let element in town) {
				if (index < 7) {
					val = +town[element];
					// val = +formatDecimal.format(town[element]); // not working

					minVal = val < minVal ? val : minVal;
					maxVal = val > maxVal ? val : maxVal;

					if (countyAvgs.length <= index) {
						countyAvgs.push(val);
					} else {
						countyAvgs[index] = countyAvgs[index] + val;
					}

					townData.push(val);
				}
				index++;
			}

			chartData.push({
				label: town['Town'],
				data: townData,
				// datalabels: {
				// 	display: false,
				// 	align: 'end',
				// 	anchor: 'center',
				// 	backgroundColor: function (context) {
				// 		return 'white';
				// 		// return context.dataset.borderColor;
				// 	},
				// 	borderColor: 'gray',
			    //     borderWidth: 1,
				// 	borderRadius: 4,
				// 	color: 'black',
				// 	font: {
				// 		weight: 'bold',
				// 		size: 12,
				// 		lineHeight: 1.0,
				// 	},
				// 	offset: 8,
				// 	padding: 3,
				// 	// formatter: Math.round
				// },
				hidden: isHidden,
				type: 'bar'
			});
		});

		countyAvgs.forEach((yearSum, j) => {
			let yearAvg = (yearSum / selectedCountyData.length);
			countyAvgs[j] = (Math.round(yearAvg * 100) / 100).toFixed(2); // formatDecimal.format(yearAvg);
		});

		// prepend County Averages
		chartData.unshift({
			label: 'County Average',
			data: countyAvgs,
			// datalabels: {
			// 	display: false,
			// 	align: 'end',
			// 	anchor: 'start',
			// 	backgroundColor: function (context) {
			// 		return context.dataset.borderColor;
			// 	},
			// 	borderRadius: 4,
			// 	color: 'white',
			// 	font: {
			// 		weight: 'bold',
			// 		size: 12,
			// 	},
			// 	offset: 8,
			// 	padding: 4,
			// 	// formatter: Math.round
			// },
			type: 'line',
			order: -1,
			borderDash: [1, 3],
			borderColor: 'rgba(0, 0, 0, .8)',
			borderWidth: 1,
			backgroundColor: 'rgb(255, 0, 0)',
			pointStyle: 'triangle',
			pointRadius: 8,
			hoverBorderWidth: 10,
		});


		theChart = new Chart(ctx, {
			// type: 'bar',
			options: {
				animation: true,
				borderWidth: 2,
				// borderColor: 'rgb(255,0,0)',
				maintainAspectRatio: false,
				responsive: true,
				// all these (default) events trigger a hover and are passed to all plugins, unless limited at plugin options
				// events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				plugins: {
					title: {
						display: true,
						text: stateAbbrev + ' Property Tax Rates',
						color: '#373c44',
						font: {
							size: 20,
							weight: 'bold',
						},
						padding: {
							top: 2,
							left: 0,
							right: 0,
							bottom: 10
						}
					},
					subtitle: {
						display: true,
						text: chartData[2].label + ', ' + stateAbbrev,
						color: '#373c44',
						font: {
						  size: 18,
						  weight: 'bold',
						  // style: 'italic'
						},
						padding: {
						  bottom: 10
						}
					},
					htmlLegend: {
						containerID: 'legend-container',
						// htmlLegend will only receive click events
        				// events: ['click']
					},
					legend: {
						display: false,
						position: 'top',
						events: ['click'],
						onClick: (event, legendItem, legend) => {
							console.log(legend);
						},
						fullSize: true,
						labels: {
							font: {
								size: 14,
							},
							boxHeight: 4,
							boxWidth: 4,
							padding: 16,
							usePointStyle: true,
							pointStyle: 'rect',
							pointStyleRadius: 1,
						}
					},
					tooltip: {
						enabled: true,
						displayColors: false,
						titleFont: {
							size: 18,
							weight: 'bold',
						},
						bodyFont: {
							size: 18,
							weight: 'bold',
						}
					},
					// annotation: {
					// 	annotations: {
							// annotation1,
							// annotation2,
					// },
					// datalabels: {
					// 	color: 'white',
					// 	display: function (context) {
					// 		return false;
					// 		// return context.dataset.data[context.dataIndex] > 15;
					// 	},
					// 	font: {
					// 		weight: 'bold',
					// 		size: 22,
					// 	},
					// 	formatter: Math.round
					// },
					// autocolors: {
					// 	mode: 'data'
					// },
				// }
				},
				scales: {
					x: {
						title: {
							display: true,
							text: 'Year',
							color: '#373c44',
							font: {
								size: 20,
								weight: 'bold',
								lineHeight: 1.2,
							},
							padding: {
								top: 10,
								left: 0,
								right: 0,
								bottom: 0
							}
						},
						ticks: {
							font: {
								size: 16,
							}
						}
					},
					y: {
						title: {
							display: true,
							text: 'Tax Rate',
							color: '#373c44',
							font: {
								size: 20,
								weight: 'bold',
								lineHeight: 1.2,
							},
							padding: {
								top: 10,
								left: 0,
								right: 0,
								bottom: 0
							}
						},
						ticks: {
							font: {
								size: 16,
							}
						},
						min: Math.floor(minVal / 5) * 5,
						max: Math.ceil(maxVal / 5) * 5, // todo
					}
				},
			},
			data: {
				labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
				datasets: getData(),
			},
			plugins: [htmlLegendPlugin],
		});
	}
})();
